
import { Avatar, Box, Chip, Grid, Tooltip } from '@mui/material';
import './item-card.css';
import { Mail, MoreHoriz, Phone } from '@mui/icons-material';
import * as componentActions from 'src/redux/actions/users';
import { getById } from "src/services/user.service";
import { PapiroConsole } from 'src/utils/papiroConsole';
import { useDispatch } from 'react-redux';

const UserCard = (props) => {
    const { user, intl, history, lang, setNotification, setLoading } = props

    const dispatch = useDispatch()
    
    const goToUser = async () => {
        if (user && user.id) {
            setLoading(true)
            const response = await getById(user.id)
            if (response.success && response.data) {
                setLoading(false)
                dispatch(componentActions.addCurrent(response.data))
            }
            setLoading(false)
            history.push(`/${lang}/user-edit`)
        }
    }

    return (
        <Grid item container spacing={2} lg={12} md={12} sm={12} xs={12} className="cardItem" direction="row" alignItems="center" >
            <Grid item lg={3} md={3} sm={4} xs={4} className="requestinguser">
                <Grid container direction="column" alignItems="center">
                    <Grid item>
                        <Avatar alt={user.name}>
                            {user.name ? user.name.charAt(0) : ""}
                        </Avatar>
                    </Grid>
                    <Grid item>
                        <span>{user.name}</span>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item container lg={9} md={9} sm={8} xs={8} direction="row" alignItems="center" justifyContent="space-between" >
                <Grid item lg={3} md={3} sm={4} xs={4} style={{ display: "flex", alignItems: "center" }} onClick={goToUser}>
                    <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.5}>
                        <span className="boldLine-two" style={{ cursor: "pointer" }}>
                            ID {user.id}
                        </span>
                        {(() => {
                            const tags = user.tags ? user.tags.split(',').filter(Boolean) : []
                            if (tags.length === 0) return null
                            const MAX_VISIBLE = 3
                            const visible = tags.slice(0, MAX_VISIBLE)
                            const hidden = tags.slice(MAX_VISIBLE)
                            return (
                                <>
                                    {visible.map((tag, i) => {
                                        const chip = <Chip key={i} label={tag.length > 50 ? tag.slice(0, 50) + '…' : tag} size="small" sx={{ height: 20, fontSize: 11 }} onClick={e => e.stopPropagation()} />
                                        return tag.length > 50 ? <Tooltip key={i} title={tag}>{chip}</Tooltip> : chip
                                    })}
                                    {hidden.length > 0 && (
                                        <Tooltip
                                            title={
                                                <Box display="flex" flexWrap="wrap" gap={0.5} p={0.5}>
                                                    {hidden.map((tag, i) => (
                                                        <Chip key={i} label={tag.length > 50 ? tag.slice(0, 50) + '…' : tag} title={tag.length > 50 ? tag : undefined} size="small" sx={{ bgcolor: 'grey.200', color: 'text.primary', height: 20, fontSize: 11 }} />
                                                    ))}
                                                </Box>
                                            }
                                        >
                                            <Chip
                                                icon={<MoreHoriz style={{ fontSize: 14 }} />}
                                                label={`+${hidden.length}`}
                                                size="small"
                                                variant="outlined"
                                                sx={{ height: 20, fontSize: 11 }}
                                                onClick={e => e.stopPropagation()}
                                            />
                                        </Tooltip>
                                    )}
                                </>
                            )
                        })()}
                    </Box>
                </Grid>
                <Grid item lg={5} md={5} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                    <Mail style={{ marginRight: 4 }} />
                    <span style={{ wordBreak: "break-word" }}>{user.email}</span>
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                    {user.phone && (
                        <>
                            <Phone style={{ marginRight: 4 }} />
                            <span>{user.phone}</span>
                        </>
                    )}
                </Grid>
            </Grid>
        </Grid>
    )
}
export default UserCard
